import { render, staticRenderFns } from "./personal.view.vue?vue&type=template&id=0b639b9f&scoped=true"
import script from "./personal.view.vue?vue&type=script&lang=js"
export * from "./personal.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b639b9f",
  null
  
)

export default component.exports